module.exports = __webpack_public_path__ + "src/img/pieChart.0311503c5157f0539b6ea8c274f7d948.png";